module.exports = __webpack_public_path__ + "static/img/big_btn.6276a151.png";